import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Ambassador } from "../../../domain/entities/assignment-queue";
import { type RouteAssignmentDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listAmbassadors = createAsyncThunk<
  Ambassador[],
  void,
  { dispatch: RouteAssignmentDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_AMBASSADORS, async (_, { extra }) => {
  return await extra.routeAssignmentRepo.listAmbassadors();
});
